import React from "react";

export default function ErrorOcc() {
  return (
    <>
      <div className="middleEle">
        <h3 className="middleHeader">Error Occured!</h3>
      </div>
      {/* <h1>Page Not Found</h1> */}
    </>
  );
}
